import React, { useEffect, useRef, useState } from "react";
import { CustomDropDownProps } from "./types";
import { useTranslation } from "react-i18next";
import ArrowBottomIcon from "../../assets/icons/filter-arrow-bottom.svg";
import "./index.less";

const CustomDropDownComponent: React.FC<CustomDropDownProps> = ({
  isFilter = false,
  title,
  options,
  selectedValue,
  onSelect,
  triggerElement,
  onClose,
}) => {
  const { t } = useTranslation();
  const dropdownRef = useRef<HTMLDivElement>(null);
  const [position, setPosition] = useState({ top: 0, right: 0 });
  const [isPositioned, setIsPositioned] = useState(false);

  useEffect(() => {
    const calculatePosition = () => {
      if (triggerElement.current && dropdownRef.current) {
        const triggerRect = triggerElement.current.getBoundingClientRect();
        const dropdownWidth = dropdownRef.current.offsetWidth;
        const top = triggerRect.height + 10;
        let right;

        if (dropdownWidth <= triggerRect.width) {
          right = window.innerWidth - triggerRect.right;
        } else {
          right = 0;
        }

        setPosition({ top, right });
        setIsPositioned(true);
      }
    };

    calculatePosition();

    window.addEventListener("resize", calculatePosition);
    return () => {
      window.removeEventListener("resize", calculatePosition);
    };
  }, [triggerElement]);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target as Node) &&
        triggerElement.current &&
        !triggerElement.current.contains(event.target as Node)
      ) {
        onClose();
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [onClose, triggerElement]);

  return (
    <div
      ref={dropdownRef}
      className="custom-dropdown"
      style={{
        top: `${position.top}px`,
        right: `${position.right}px`,
        visibility: isPositioned ? "visible" : "hidden",
        opacity: isPositioned ? 1 : 0,
      }}
      onClick={(e) => e.stopPropagation()}
    >
      {isFilter ? (
        <div className="custom-dropdown-title filter-title">
          {t("filter")} <span className="text-medium">{t("by")}</span>
          <img src={ArrowBottomIcon} className="arrow-bottom-icon" alt="filter" />
        </div>
      ) : (
        <div className="custom-dropdown-title">{title}</div>
      )}
      {options.map((option) => (
        <div
          key={option.value}
          className={`custom-dropdown-option ${selectedValue === option.value ? "custom-dropdown-selected" : ""}`}
          onClick={() => {
            onSelect(option.value);
            onClose();
          }}
        >
          <span className={option.value === "ALL" ? "uppercase" : ""}>
            {option.label}
            {option.value === "ALL" && <span className="text_light"> ( {t("by_default")} )</span>}
          </span>
          <img className="custom-dropdown-option-icon" src={option.icon} alt={option.label} />
        </div>
      ))}
    </div>
  );
};

export default CustomDropDownComponent;
